import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
  AfterViewInit,
  HostListener,
  ElementRef,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import * as fromPlantPlanet from './state/plant-planet.selectors';
import * as PlantPlanetAction from './state/plant-planet.actions';
import * as fromAuth from 'src/screens/login/state/login.selectors';
import * as lgeApp from 'src/app/state/app.actions';
import * as appConfig from 'src/app/app.constant';
import { SignaturePad } from 'angular2-signaturepad';
import * as moment from 'moment';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import * as _ from 'lodash';
import { DecimalPipe } from '@angular/common';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  ActivatedRoute,
} from '@angular/router';

import { saveAs } from 'file-saver';
import { catchError, map, Subscription, tap } from 'rxjs';
import { Observable } from 'rxjs';
import { slideInDownAnimation } from 'src/app/app.animation';
import {
  IPlantPlanet,
  IExternalData,
  LGEDataService,
  ErrorParseService,
  PermissionsService,
  AuthenticationService,
} from 'src/commons';
import { DeactivationGuard } from 'src/commons/guards/route-change.guard';
import { PreviousRouteService } from 'src/commons/services/previousRoute.service';
import { AngularMaterialService } from 'src/commons/utilities/angular.material.service';
import { LoginRedirect } from '../login/state/login.actions';
import { of } from 'rxjs';
import { skipWhile } from 'rxjs';
declare let LGEKUFX;

@Component({
  selector: 'plant-planet-screen',
  templateUrl: 'plant-planet.component.html',
  styleUrls: ['plant-planet.component.scss'],
  animations: [slideInDownAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlantPlanetScreenComponent
  implements OnInit, OnDestroy, AfterViewInit, DeactivationGuard
{
  @Input() private pending$: Observable<boolean>;
  private pendingSubscription: Subscription;
  private pending: boolean;
  @Input() private error$: Observable<string | null>;
  private errorSubscription: Subscription;
  private error: string | null;
  @Input() private stateData$: Observable<IPlantPlanet | null>;
  private stateDataSubscription: Subscription;
  private stateData: IPlantPlanet | null;
  @Input() private profileData$: Observable<IExternalData | null>;
  private profileDataSubscription: Subscription;
  private profileData: IExternalData | null;

  ppForm: FormGroup;
  minEffdt = new Date('');
  formData;
  formId = 0;
  formPPName = '';
  payToOption = false;
  useGatorBag = false;
  isShowSaveAsDraft = true;
  isLoadingFormPP = false;
  isValidatingRow = true;
  totalAmount = '0';
  ValidatingRow: number;
  isFilled = true;
  isValid = true;
  companyData: any = [];
  expTypeData: any = [];
  expOrgData: any = [];
  projTaskData: any = [];
  numPipe = new DecimalPipe('en-Us');
  isApproving = false;
  isShowApproveBtn = false;
  isShowSubmitBtn = false;
  isShowWithDrawBtn = false;
  minDate = new Date();
  serviceAreas = appConfig.SHARE_ARRAYS.serviceAreas;
  states = appConfig.SHARE_ARRAYS.states;
  titles = ['Mr.', 'Mrs.', 'Ms.', 'Dr.'];
  treeTypes = [
    'Canopy',
    'Hardwood',
    'Mix of Canopy and Understory',
    'Mix of Hardwood and Softwood',
    'Native',
    'Non-native**',
    'Softwood',
    'Understory',
  ];
  accDistData: any = [
    { company: [], project: [], task: [], expOrg: [], expType: [] },
    { company: [], project: [], task: [], expOrg: [], expType: [] },
  ];
  isShowLeaveDialog = false;
  isReadOnly = true;
  isEditableAccDist = true;
  isPPApprover = false;
  isFormExpired = false;
  previousURL: any;
  @ViewChild(SignaturePad) signaturePad: SignaturePad;

  signaturePadOptions: Object = {
    dotSize: 0.6,
    minWidth: 0.6,
    maxWidth: 1.2,
    canvasWidth: 400,
    canvasHeight: 160,
    throttle: 0,
    backgroundColor: 'rgba(238,238,238,1)',
  };

  twoDecMask = createNumberMask({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: false,
    thousandsSeparatorSymbol: '',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2,
    integerLimit: null,
    requireDecimal: false,
    allowNegative: false,
    allowLeadingZeroes: true,
  });

  noDecMask = createNumberMask({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: false,
    thousandsSeparatorSymbol: '',
    allowDecimal: false,
    decimalSymbol: '.',
    decimalLimit: null,
    integerLimit: null,
    requireDecimal: false,
    allowNegative: false,
    allowLeadingZeroes: true,
  });

  showErrorMessage: string;
  atOeBs: boolean;
  isInternal: boolean;
  isMaxLength = false;

  @ViewChild('fileInput1') fileInput1: ElementRef;
  @ViewChild('fileInput2') fileInput2: ElementRef;
  @ViewChild('fileInput3') fileInput3: ElementRef;
  @ViewChild('fileInput4') fileInput4: ElementRef;

  fileId = '0';
  attachId = -1;
  W9AttachDeleted = this.fb.array([]);
  SchematicAttachDeleted = this.fb.array([]);
  PreviousEffortAttachDeleted = this.fb.array([]);
  AddAttachDeleted = this.fb.array([]);
  isAttached = false;
  taxExemptList: any;

  @HostListener('window:beforeunload', ['$event'])
  handleClose($event) {
    if (!this.isShowLeaveDialog && this.ppForm.dirty) {
      return false;
    }
    return true;
  }

  constructor(
    private store: Store<fromPlantPlanet.State>,
    private storeAuth: Store<fromAuth.State>,
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    private ams: AngularMaterialService,
    private _dataService: LGEDataService,
    private errorParse: ErrorParseService,
    private router: Router,
    private permissionsService: PermissionsService,
    private authService: AuthenticationService,
    private previousRouteService: PreviousRouteService,
    private route: ActivatedRoute
  ) {
    this.isInternal = this.permissionsService.isInternal();
    this.isPPApprover = this.hasRole('PFTPAPPROVER');
    if (this.hasRole('ADMIN')) {
      this._dataService.GetTaxExemptSubsections().subscribe({
        next: (data) =>
          (this.taxExemptList = appConfig.SHARE_ARRAYS.taxExemptList),
      });
    }
    this.selectState();
  }

  ngOnInit() {
    this.startSubscriptions();
    this.createForms();
  }

  private createAttachment(fileId, base64, name, size, type): FormGroup {
    return this.fb.group({
      attachId: [-1],
      formId: [-1],
      fileId: [fileId],
      attachString: [base64],
      attachName: [name],
      attachSize: [size],
      attachType: [type],
      deleteIt: [0],
    });
  }
  ngAfterViewInit() {
    this.checkFormExpired().subscribe({
      next: (result) => {
        // if (result === 'Expired' && !this.hasRole('ADMIN|PFTPAPPROVER')) {
        //   // this.ams.showAlert(
        //   //   'Expired',
        //   //   'Plant for the Planet Application has been expired!'
        //   // );
        //   this.ref.markForCheck();
        // }
        if (this.formId) {
          this.store.dispatch(
            new PlantPlanetAction.LoadPlantPlanetState(this.formId)
          );
        } else {
          setTimeout(() => {
            this.AutopopulateInfo();
            this.checkOrgName();
            this.isEditableAccDist = !this.isInternal;
            this.isShowSaveAsDraft = !this.isInternal;
            this.isShowSubmitBtn = !this.isInternal;
            this.ppForm
              .get(['AuthorizedRep', 'date'])
              .setValue(moment().format('MM/DD/YYYY'));
            this.isShowLeaveDialog = this.isInternal; // internal can't submit, so no need leave dialog
            this.ams.closeDialog();
            this.ref.markForCheck();
          });
        }
      },
    });
  }

  canDeactivate(
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return of(true);
    // return Observable.fromPromise(this.sessionCheck())
    //   .exhaustMap(result => {
    //     if (result)
    //       return Observable.fromPromise(this.confirmDialog());
    //     else
    //       return Observable.of(true);
    //   })
  }

  private confirmDialog(): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.isShowLeaveDialog && this.ppForm.dirty) {
        this.ams.showConfirm(
          'Alert!',
          ' Are you sure you want to navigate away from this page? If you proceed, ALL of your changes will be lost. Press Yes to continue, or Cancel to stay on the current page.'
        );
        this.ams.confirm
          .afterClosed()
          .subscribe((ans) => resolve(ans === 'yes'));
      } else {
        resolve(true);
      }
    });
  }

  // private sessionCheck(): Observable<boolean> {
  //   return this.authService.validateSession(this.permissionsService.getCurrentSession()).pipe(
  //     map((result: boolean) => {
  //       return of(result);
  //     }),
  //     catchError(error => of(false))
  //   )
  // .then((result) => {
  //   if (result)
  //     resolve(true)
  //   else
  //     resolve(false)
  // })
  // .catch(error => resolve(false))
  // }

  drawComplete() {
    let base64Raw = this.signaturePad.toDataURL('base64').toString();
    this.ppForm.get(['AuthorizedRep', 'signature']).setValue(base64Raw);
  }

  drawStart() {
    // console.log('begin signing');
  }

  drawClear() {
    this.ppForm.get(['AuthorizedRep', 'signature']).setValue('');
    this.ppForm.get(['AuthorizedRep', 'signature']).updateValueAndValidity();
    this.signaturePad.clear();
  }

  setLimitTextArea(value, maxLength: number): any {
    let trimValue = value.replace(/\s/g, '');
    while (trimValue.length > maxLength) {
      value = value.substring(0, value.length - 1);
      trimValue = value.replace(/\s/g, '');
    }
    return value;
  }

  private selectState(): void {
    if (!this.isInternal) {
      this.profileData$ = this.storeAuth
        .select(fromAuth.getExternalProfile)
        .pipe(
          skipWhile(
            (stateData) => stateData === undefined || stateData === null
          )
        );
    }
    this.pending$ = this.store.select(
      fromPlantPlanet.getPlantPlanetScreenPending
    );
    this.stateData$ = this.store.select(fromPlantPlanet.getPlantPlanetState);
    this.error$ = this.store
      .select(fromPlantPlanet.getPlantPlanetScreenError)
      .pipe(
        skipWhile(
          (error) => error === undefined || error === null || error === ''
        )
      );
  }

  private displayLoader(pending: boolean): void {
    if (pending) {
      setTimeout(() => {
        this.ams.showLoader('Loading...');
        this.ref.markForCheck();
      });
    } else {
      this.ams.closeDialog().then(() => {
        if (
          this.error !== null &&
          this.error !== undefined &&
          this.error !== ''
        ) {
          this.displayError(this.error);
        }
      });
    }
  }

  private displayError(error: any): void {
    let errorMessage;
    if (this.errorParse.foundKeyWord(error, 'CORPCOMMONWS')) {
      errorMessage = this.errorParse.translateCCError(error);
    } else {
      errorMessage = error instanceof Object ? error.message : error;
    }
    this.ams.showAlert('Loading Error', errorMessage);
    this.ams.alert.afterClosed().subscribe((result) => {
      this.store.dispatch(new PlantPlanetAction.PlantPlanetScreenErrorReset());
    });
  }

  private createForms(): void {
    this.ppForm = this.fb.group({
      AccDistribution: this.fb.array([
        this.fb.group({
          accDistributionId: [null],
          formId: [null],
          company: [''],
          project: [''],
          task: [''],
          expType: [''],
          expOrg: [''],
          amount: [''],
        }),
        this.fb.group({
          accDistributionId: [null],
          formId: [null],
          company: [''],
          project: [''],
          task: [''],
          expType: [''],
          expOrg: [''],
          amount: [''],
        }),
      ]),
      OrgContactInfoFormPP: this.fb.group({
        orgContactInfoFormPP_Id: [null],
        title: [''],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        phone: [
          '',
          [
            Validators.required,
            Validators.pattern(new RegExp(/^\d{3}-\d{3}-\d{4}/)),
          ],
        ],
        email: [
          '',
          [
            Validators.required,
            Validators.maxLength(254),
            Validators.pattern(
              new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
            ),
          ],
        ],
      }),
      OrgInfoFormPP: this.fb.group({
        orgInfoFormPP_Id: [null],
        name: ['', [Validators.required, Validators.maxLength(80)]],
        EIN: [
          '',
          [
            Validators.required,
            Validators.maxLength(10),
            Validators.pattern(new RegExp(/^\d{2}-\d{7}/)),
          ],
        ],
        address1: ['', [Validators.required, Validators.maxLength(35)]],
        address2: ['', [Validators.maxLength(35)]],
        city: ['', [Validators.required, Validators.maxLength(25)]],
        state: ['', Validators.required],
        county: ['', Validators.required],
        zipCode: [
          '',
          [
            Validators.required,
            Validators.pattern(new RegExp(/^\d{5}(-?\d{4})?$/)),
          ],
        ],
        payToOption: ['No'],
        payTo: ['', Validators.maxLength(80)],
        subsection_501: [''],
      }),
      AuthorizedRep: this.fb.group({
        authRepId: [null],
        title: [''],
        name: ['', [Validators.required, Validators.maxLength(50)]],
        date: ['', [Validators.required]],
        signature: ['', [Validators.required]],
      }),
      FormPPLogInfo: this.fb.group({
        formPPId: [null],
        formPPLogId: [null],
        effdt: [''],
        action: [''],
        comment: [''],
        empId: [''],
        empName: [''],
        empTypeForLog: [''],
        status: [''],
        title: [''],
      }),
      userId: [''],
      FormPP_Id: [null],
      FormPPName: [''],
      effdt: [new Date()],
      statusEffdt: [new Date()],
      projectName: ['', [Validators.required, Validators.maxLength(30)]],
      orgContactInfoFormPP_Id: [null],
      orgInfoFormPP_Id: [null],
      authRepId: [null],
      serviceArea: [[], Validators.required],
      serviceAreaArray: [[]],
      promotionEffort: ['', Validators.required],
      plantingEffort: ['', Validators.required],
      numTreePlanted: ['', Validators.required],
      treeSize: ['', Validators.required],
      treeType: [[], Validators.required],
      treeTypeArray: [[]],
      plantDate: [new Date(), Validators.required],
      projNarrative: ['', Validators.required],
      projPartner: ['', Validators.required],
      previousEffortAttach: this.fb.array([]),
      schematicAttach: this.fb.array([]),
      W9Attach: this.fb.array([]),
      AddAttach: this.fb.array([]),
      budgetNarr: ['', Validators.required],
      maintenanceSchedNarr: ['', Validators.required],
      overseePerson: ['', Validators.required],
      hasTreeWatered: ['No', Validators.required],
      useGatorBags: ['No', Validators.required],
      numBagsUse: [''],
      amountRequest: ['', Validators.required],
      projectCost: ['', Validators.required],
      amount: [''],
      payment: ['CHECK', Validators.required],
      statusId: [null],
      statusDescr: [''],
      requestNo: [''],
      deleteIt: [''],
    });

    this.ppForm
      .get(['OrgInfoFormPP', 'payToOption'])
      .valueChanges.subscribe((value: string) => {
        this.payToOption = value === 'Yes';
        if (!this.payToOption) {
          this.ppForm.get(['OrgInfoFormPP', 'payTo']).setValue('');
          this.ppForm.get(['OrgInfoFormPP', 'payTo']).setValidators([]);
          this.ppForm.get(['OrgInfoFormPP', 'payTo']).updateValueAndValidity();
        } else {
          this.ppForm
            .get(['OrgInfoFormPP', 'payTo'])
            .setValidators([Validators.required]);
          this.ppForm
            .get(['OrgInfoFormPP', 'name'])
            .setValidators([Validators.required]);
        }
        this.ppForm.get('OrgInfoFormPP').updateValueAndValidity();
      });
    this.ppForm.get('useGatorBags').valueChanges.subscribe((value: string) => {
      this.useGatorBag = value === 'Yes';
      if (!this.useGatorBag) {
        this.ppForm.get('numBagsUse').setValue('');
        this.ppForm.get('numBagsUse').setValidators([]);
        this.ppForm.get('numBagsUse').updateValueAndValidity();
      } else {
        this.ppForm.get('numBagsUse').setValidators([Validators.required]);
        this.ppForm.get('numBagsUse').updateValueAndValidity();
      }
    });
    this.ppForm.controls['AccDistribution'].valueChanges.subscribe((value) => {
      const validateObj =
        this.isValidatingRow && this.ValidatingRow === undefined
          ? value[0]
          : value[this.ValidatingRow];
      if (validateObj !== undefined) {
        if (
          validateObj.company !== '' &&
          validateObj.project !== '' &&
          validateObj.task !== '' &&
          validateObj.expType !== '' &&
          validateObj.expOrg !== '' &&
          this.isValidatingRow
        ) {
          this.isValidatingRow = false;
          this.Validate_Project_Task(validateObj);
        }
        this.callValidateAPI();
      }
    });

    this.ppForm.controls['W9Attach'].valueChanges.subscribe((value) => {
      const W9Array = this.ppForm.controls['W9Attach'] as FormArray;
      const schemArray = this.ppForm.controls['schematicAttach'] as FormArray;
      const prevArray = this.ppForm.controls[
        'previousEffortAttach'
      ] as FormArray;
      this.isAttached = true;
      if (
        W9Array.value.length === 0 ||
        schemArray.value.length === 0 ||
        prevArray.value.length === 0
      ) {
        this.isAttached = false;
      }
    });

    this.ppForm.controls['schematicAttach'].valueChanges.subscribe((value) => {
      const W9Array = this.ppForm.controls['W9Attach'] as FormArray;
      const schemArray = this.ppForm.controls['schematicAttach'] as FormArray;
      const prevArray = this.ppForm.controls[
        'previousEffortAttach'
      ] as FormArray;
      this.isAttached = true;
      if (
        W9Array.value.length === 0 ||
        schemArray.value.length === 0 ||
        prevArray.value.length === 0
      ) {
        this.isAttached = false;
      }
    });

    this.ppForm.controls['previousEffortAttach'].valueChanges.subscribe(
      (value) => {
        const W9Array = this.ppForm.controls['W9Attach'] as FormArray;
        const schemArray = this.ppForm.controls['schematicAttach'] as FormArray;
        const prevArray = this.ppForm.controls[
          'previousEffortAttach'
        ] as FormArray;
        this.isAttached = true;
        if (
          W9Array.value.length === 0 ||
          schemArray.value.length === 0 ||
          prevArray.value.length === 0
        ) {
          this.isAttached = false;
        }
      }
    );

    if (
      this.isPPApprover ||
      (this.hasRole('ADMIN') &&
        this.ppForm.value.statusId !== 2 &&
        this.ppForm.value.statusId !== null)
    ) {
      this.ppForm
        .get(['AccDistribution', 0, 'company'])
        .setValidators([Validators.required]);
      this.ppForm
        .get(['AccDistribution', 0, 'project'])
        .setValidators([Validators.required]);
      this.ppForm
        .get(['AccDistribution', 0, 'task'])
        .setValidators([Validators.required]);
      this.ppForm
        .get(['AccDistribution', 0, 'expType'])
        .setValidators([Validators.required]);
      this.ppForm
        .get(['AccDistribution', 0, 'expOrg'])
        .setValidators([Validators.required]);
      this.ppForm
        .get(['AccDistribution', 0, 'amount'])
        .setValidators([Validators.required]);
      this.ppForm.get(['AccDistribution', 0]).updateValueAndValidity();
    }
  }

  onAccDistSelect(value, index: number, selectedData: string): void {
    if (value) {
      this.ValidatingRow = index;
      this.isValidatingRow = true;
      switch (selectedData) {
        case 'company':
          this.populateCompany(value, index);
          this.ppForm
            .get(['AccDistribution', index.toString(), 'project'])
            .setValue('');
          this.ppForm
            .get(['AccDistribution', index.toString(), 'task'])
            .setValue('');
          break;
        case 'project':
          this.ppForm
            .get(['AccDistribution', index.toString(), 'task'])
            .setValue('');
          break;
        case 'task':
          this.ppForm
            .get(['AccDistribution', index.toString(), 'expType'])
            .setValue('');
          this.ppForm
            .get(['AccDistribution', index.toString(), 'expOrg'])
            .setValue('');
          break;

        case 'expType':
          this.ppForm
            .get(['AccDistribution', index.toString(), 'expOrg'])
            .setValue('');
          break;
      }
      this.callValidateAPI();
    }
  }

  populateCompany(value, index) {
    if (this.accDistData[0].company !== undefined) {
      this.ref.markForCheck();
      if (index === 0) {
        const selectedComp = this.accDistData[0].company.filter(
          (x) => x.code === value
        );
        let i = 1;
        for (i; i < this.accDistData.length; i++) {
          // 4 to this.accDistData.length
          this.accDistData[i].company = selectedComp;
          this.ppForm
            .get(['AccDistribution', i.toString(), 'company'])
            .setValue('');
        }
      } else {
        if (this.ppForm.controls['AccDistribution'].value[0].company === '') {
          this.ams.showAlert('Error!', 'Please select company for first row!');
          this.ppForm
            .get(['AccDistribution', index.toString(), 'company'])
            .setValue('');
          return;
        }
      }
    } else {
      this.populateCompany(value, index);
    }
  }

  onAmountChange(value, index: number) {
    let tempAmount = ''; // =
    if (value !== '' && value.includes('.')) {
      const dec = value.split('.')[1];
      if (dec === '00' || dec === '' || dec === '0') {
        tempAmount = value.split('.')[0];
      } else {
        tempAmount = this.numPipe
          .transform(+parseFloat(value).toFixed(2), '1.2-2')
          .replace(/,/g, '');
      }
    } else {
      tempAmount = value;
    }
    this.ppForm
      .get(['AccDistribution', index.toString(), 'amount'])
      .setValue(tempAmount);
  }

  calculateTotalAmount() {
    const projectDetails = this.ppForm.controls['AccDistribution'].value;
    this.totalAmount = '0';
    let newTotalAmount = 0;
    projectDetails.forEach((project) => {
      const amount = project.amount;
      let newAmount;
      if (amount === undefined || amount === null || amount === '') {
        newAmount = 0;
      } else {
        newAmount = parseFloat(amount);
      }
      newTotalAmount += newAmount; //+(parseFloat(project.amount) || 0).toFixed(2);+
    });
    let temp = this.numPipe
      .transform(newTotalAmount.toFixed(2), '1.2-2')
      .replace(/,/g, '');
    temp = temp.split('.')[1] === '00' ? temp.split('.')[0] : temp;
    this.totalAmount = temp;
  }

  getAccountingDistributionData(accDistPara) {
    this._dataService
      .AccDistInfo_GetActiveByName([accDistPara, 'PP'])
      .subscribe({
        next: (data) => {
          if (data) {
            switch (accDistPara) {
              case 'COMPANY':
                this.companyData = data;
                for (let i = 0; i < this.accDistData.length; i++) {
                  // 4 to this.accDistData.length
                  this.accDistData[i].company = data;
                }
                this.ref.markForCheck();
                break;
              case 'EXP_TYPE':
                this.expTypeData = data;
                for (let i = 0; i < this.accDistData.length; i++) {
                  // 4 to this.accDistData.length
                  this.accDistData[i].expType = data;
                }
                this.ref.markForCheck();
                break;
              case 'EXP_ORG':
                this.expOrgData = data;
                for (let i = 0; i < this.accDistData.length; i++) {
                  // 4 to this.accDistData.length
                  this.accDistData[i].expOrg = data;
                }
                this.ref.markForCheck();
                break;
            }
          }
        },
        error: (error) => {
          this.ams.showAlert(
            'Error!',
            `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
          );
          this.ref.markForCheck();
        },
      });
  }

  getProjectTaskData(projTaskPara) {
    this._dataService
      .ProjectTaskInfo_GetActiveByName([projTaskPara, 'PP'])
      .subscribe({
        next: (data) => {
          if (data) {
            this.projTaskData = data;
            for (let i = 0; i < this.accDistData.length; i++) {
              // 4 to this.accDistData.length
              this.accDistData[i].project = _.uniqBy(data, 'project');
              this.accDistData[i].task = _.uniqBy(data, 'task');
            }
            this.ref.markForCheck();
          }
        },
        error: (error) => {
          this.ams.showAlert(
            'Error!',
            `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
          );
          this.ref.markForCheck();
          return of(error);
        },
      });
  }

  callValidateAPI() {
    for (let i = 0; i < this.accDistData.length; i++) {
      // 4 to this.accDistData.length
      const validateObj = this.ppForm.controls['AccDistribution'].value[i];
      if (
        validateObj.company !== '' &&
        validateObj.project !== '' &&
        validateObj.task !== '' &&
        validateObj.expType !== '' &&
        validateObj.expOrg !== '' &&
        validateObj.amount !== ''
      ) {
        this.isFilled = true;
      } else if (
        validateObj.company === '' &&
        validateObj.project === '' &&
        validateObj.task === '' &&
        validateObj.expType === '' &&
        validateObj.expOrg === '' &&
        validateObj.amount === ''
      ) {
        this.isFilled = true;
      } else {
        this.isFilled = false;
        break;
      }
    }
  }

  Validate_Project_Task(data) {
    const validateObj: any = {
      project: data.project,
      task: data.task,
      expenditureType: data.expType,
      expenditureOrg: data.expOrg,
      company: data.company,
    };
    const jsonData = JSON.stringify(validateObj);
    this.ams.showLoader('Validating...');
    if (this.isPPApprover || this.hasRole('ADMIN')) {
      this._dataService.Validate_Project_Task(jsonData).subscribe({
        next: (data) => {
          this.ams.closeDialog();
          if (data) {
            const validateResult = JSON.parse(data);
            this.isValid = validateResult.statusCode === 'VALID' ? true : false;
            if (!this.isValid) {
              this.ams.showAlert(
                validateResult.statusCode,
                validateResult.statusMessage
              );
            }
            this.ref.markForCheck();
          }
        },
        error: (error) => {
          this.isValid = false;
          this.ams.closeDialog();
          this.ams.showAlert(
            'Unable to validate!',
            `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
          );
          this.ref.markForCheck();
        },
      });
    } else {
      this.ams.closeDialog();
      this.isValid = true;
      this.ref.markForCheck();
    }
  }

  checkFormExpired(): Observable<string> {
    if (this.hasRole('ADMIN|PFTPAPPROVER')) {
      this.isFormExpired = false;
      return of('Open');
    } else {
      return this._dataService.GetActiveForm().pipe(
        map((data: any) => {
          this.isFormExpired = data.find((item) => item === 'PP') === undefined;
          this.isReadOnly = !this.isReadOnly
            ? this.isFormExpired
            : this.isReadOnly;
          this.ref.markForCheck();
          if (this.isFormExpired) {
            this.signaturePad.off();
            this.isShowLeaveDialog = false;
            return 'Expired';
          } else {
            return 'Open';
          }
        }),
        catchError((error) => {
          this.ams.showAlert('Error!', 'Failed checking form expiration!');
          this.ref.markForCheck();
          return of('Error');
        })
      );
    }
  }

  openSidenav(): void {
    this.store.dispatch(new lgeApp.OpenSidenav());
  }

  hasRole(role: string) {
    return this.permissionsService.hasRoles(role);
  }

  findInvalidControls() {
    const invalid = [];
    const controls = this.ppForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  private startSubscriptions(): void {
    this.pendingSubscription = this.pending$.subscribe((data) => {
      this.pending = data;
      this.displayLoader(this.pending);
      this.ref.markForCheck();
    });
    this.errorSubscription = this.error$.subscribe((data) => {
      this.error = data;
      this.ref.markForCheck();
    });
    if (!this.isInternal) {
      this.profileDataSubscription = this.profileData$.subscribe((data) => {
        this.profileData = data;
        this.ref.markForCheck();
      });
    }

    this.stateDataSubscription = this.stateData$.subscribe((data) => {
      if (data !== null) {
        this.formData = JSON.parse(JSON.stringify(data[0]));
        if (
          !this.isInternal &&
          this.profileData.externalUser.email.toLowerCase() !==
            this.formData.userId
        ) {
          this.toHome();
        }
        if (
          !this.isInternal &&
          this.isFormExpired &&
          this.formData.statusId === 2
        ) {
          this.ams.showAlert(
            'Expired',
            'Plant for the Planet Application has been expired!'
          );
          this.ref.markForCheck();
        }
        this.formData.serviceArea = this.formData.serviceAreaArray;
        this.formData.treeType = this.formData.treeTypeArray;
        const AddLength = this.formData.AddAttach.length;
        for (let i = 0; i < AddLength; i++) {
          (<FormArray>this.ppForm.controls['AddAttach']).push(
            this.createAttachment('NA', '', '', '0', 'Additional')
          );
        }
        // init W9Array
        if (this.formData.W9Attach.length > 0) {
          (<FormArray>this.ppForm.get('W9Attach')).push(
            this.createAttachment('NA', '', '', '0', 'W9Attach')
          );
        }

        if (this.formData.previousEffortAttach.length > 0) {
          (<FormArray>this.ppForm.get('previousEffortAttach')).push(
            this.createAttachment('NA', '', '', '0', 'previousEffortAttach')
          );
        }
        // init schematic
        if (this.formData.schematicAttach.length > 0) {
          (<FormArray>this.ppForm.get('schematicAttach')).push(
            this.createAttachment('NA', '', '', '0', 'schematicAttach')
          );
        }
        this.ppForm.setValue(this.formData);
        this.checkOrgName();
        this.calculateTotalAmount();
        this.signaturePad.fromDataURL(
          this.ppForm.get(['AuthorizedRep', 'signature']).value
        );

        this.ppForm
          .get('plantDate')
          .setValue(new Date(this.formData.plantDate));

        if (this.ppForm.get('statusId').value === 2) {
          this.ppForm
            .get(['AuthorizedRep', 'date'])
            .setValue(moment().format('MM/DD/YYYY'));
        } else {
          const signDate = this.ppForm.get(['AuthorizedRep', 'date']).value;
          this.ppForm
            .get(['AuthorizedRep', 'date'])
            .setValue(moment(signDate).format('MM/DD/YYYY'));
          this.signaturePad.off();
        }
        switch (this.formData.statusId) {
          case 1: //Submitted
            this.isReadOnly = false;
            this.isShowLeaveDialog = true;
            this.isShowSaveAsDraft = false;
            break;
          case 2: //Draft
            this.isShowLeaveDialog =
              (!this.isInternal && !this.isFormExpired) || this.hasRole('DEV');
            this.isShowSaveAsDraft =
              (!this.isInternal && !this.isFormExpired) || this.hasRole('DEV');
            this.isShowSubmitBtn =
              (!this.isInternal && !this.isFormExpired) || this.hasRole('DEV');
            break;
          case 3: // Approved
            this.isReadOnly = this.hasRole('ADMIN');
            this.isEditableAccDist = this.hasRole('ADMIN');
            this.isShowLeaveDialog = this.hasRole('ADMIN');
            this.isShowSaveAsDraft = false;
            this.isShowSubmitBtn = this.hasRole('ADMIN');
            this.isShowWithDrawBtn = !this.isInternal;
            this.isValidatingRow = this.hasRole('ADMIN');
            break;
          case 4: //Rejected
            this.isReadOnly = false;
            this.isShowLeaveDialog = true;
            this.isShowSaveAsDraft = false;
            this.isShowWithDrawBtn = !this.isInternal;
            break;
          case 5: //Withdrawn
            this.isReadOnly = false;
            this.isEditableAccDist = false;
            this.isShowLeaveDialog = true;
            this.isShowSaveAsDraft = false;
            break;
          case 7: //Pending CR&CA Approval
            this.isReadOnly = this.hasRole('ADMIN');
            this.isShowLeaveDialog = !(
              this.hasRole('ADMIN') || this.hasRole('PFTPAPPROVER')
            );
            this.isShowSaveAsDraft = false;
            this.isEditableAccDist =
              this.hasRole('ADMIN') || this.hasRole('PFTPAPPROVER');
            this.isShowApproveBtn = this.hasRole('PFTPAPPROVER');
            this.isShowSubmitBtn = this.hasRole('ADMIN');
            this.isShowWithDrawBtn = !this.isInternal;
            break;
          case 10:
            this.isReadOnly = false;
            this.isEditableAccDist = false;
            this.isShowLeaveDialog = true;
            this.isShowSaveAsDraft = false;
            break;
          case 11: //Closed - Approved
            this.isReadOnly = this.hasRole('ADMIN');
            this.isEditableAccDist = this.hasRole('ADMIN');
            this.isShowLeaveDialog = true;
            this.isShowSaveAsDraft = false;
            this.isShowSubmitBtn = this.hasRole('ADMIN');
            break;
          default:
            this.isReadOnly = false;
            this.isEditableAccDist = false;
            this.isShowLeaveDialog = true;
            this.isShowSaveAsDraft = false;
            break;
        }
      }
    });
    if (this.isInternal) {
      this.getAccountingDistributionData('COMPANY');
      this.getAccountingDistributionData('EXP_TYPE');
      this.getAccountingDistributionData('EXP_ORG');
      this.getProjectTaskData('PROJ_TASK_PLUS');
    }
    this.route.params.subscribe((response) => {
      this.formId = parseInt(response['id']);
    });
  }

  private endSubscriptions(): void {
    this.pendingSubscription.unsubscribe();
    this.errorSubscription.unsubscribe();
    this.stateDataSubscription.unsubscribe();
    if (!this.isInternal) this.profileDataSubscription.unsubscribe();
  }

  onAttachFileChange(event, type: string) {
    if (event.target.files.length > 0) {
      if (event.target.files[0].type !== 'application/pdf') {
        this.fileInput1.nativeElement.value = '';
        this.ams.showAlert(
          '',
          'Only PDF file is allowed, please choose another file'
        );
      } else {
        if (event.target.files[0].size > 10485760) {
          // max 10MB - 10485760
          this.ams.showAlert(
            '',
            'Attachment size exceeds the allowable limit, please choose another file'
          );
        } else {
          this.fileId = '';
          if (this.isInternal) {
            if (this.ppForm.get([type, '0']) === null) {
              (<FormArray>this.ppForm.get(type)).push(
                this.createAttachment(
                  'NA',
                  '',
                  event.target.files[0].name,
                  event.target.files[0].size.toString(),
                  type
                )
              );
            } else {
              this.removeAttach(type);
              (<FormArray>this.ppForm.get(type)).push(
                this.createAttachment(
                  'NA',
                  '',
                  event.target.files[0].name,
                  event.target.files[0].size.toString(),
                  type
                )
              );
            }
            const reader = new FileReader();
            reader.onload = this.handleReaderForm.bind(this, type);
            reader.readAsBinaryString(event.target.files[0]);
          } else {
            if (this.ppForm.get(type).value.length > 1) this.removeAttach(type);
            let tempW9 = this.createAttachment(
              'NA',
              '',
              event.target.files[0].name,
              event.target.files[0].size.toString(),
              type
            );
            this.uploadToFileService(event.target.files[0], type).then(
              (result) => {
                if (result === 'Valid') {
                  tempW9.value.attachId = this.attachId;
                  if (this.ppForm.get([type, '0']) === null) {
                    (<FormArray>this.ppForm.get(type)).push(tempW9);
                  } else {
                    this.removeAttach(type);
                    (<FormArray>this.ppForm.get(type)).push(tempW9);
                  }
                  this.attachId = -1;
                  this.ref.markForCheck();
                }
              }
            );
          }
        }
      }
      switch (type) {
        case 'W9Attach':
          this.fileInput1.nativeElement.value = '';
          break;
        case 'previousEffortAttach':
          this.fileInput3.nativeElement.value = '';
          break;
        case 'schematicAttach':
          this.fileInput4.nativeElement.value = '';
          break;
      }
    }
  }

  removeAttach(type) {
    let W9Array = this.ppForm.get(type) as FormArray;
    W9Array.controls.forEach((item, index) => {
      W9Array.removeAt(index);
      if (item.value.attachId !== -1) {
        item.value.deleteIt = 1;
        switch (type) {
          case 'W9Attach':
            this.W9AttachDeleted.push(item as FormControl);
            break;
          case 'previousEffortAttach':
            this.PreviousEffortAttachDeleted.push(item as FormControl);
            break;
          case 'schematicAttach':
            this.SchematicAttachDeleted.push(item as FormControl);
            break;
        }
      }
    });
  }

  private uploadToFileService(file, type): Promise<any> {
    return new Promise((resolve) => {
      this.ams.showLoader('Validating file...');
      let corpCommonSessionInfo =
        this.permissionsService.getCorpCommonSessionInfo();
      var getCorpCommonSessionInfo = function (callback) {
        callback(corpCommonSessionInfo);
      };

      LGEKUFX.registerCorpCommonSessionHandler(getCorpCommonSessionInfo);
      var upload = LGEKUFX.uploadFileSync(
        file,
        (error) => {
          this.ams.closeDialog();
          if (error.message.includes('Request failed to authenticate')) {
            this.ams.showAlert(
              'Session Timeout',
              'Your session has been expired due to inactivity.  Please click OK to log in again.'
            );
            this.ams.alert.afterClosed().subscribe(() => {
              this.storeAuth.dispatch(new LoginRedirect());
            });
            setTimeout(() => {
              this.storeAuth.dispatch(new LoginRedirect());
            }, 10000);
          } else {
            this.ams.showAlert(
              'Error',
              `Failed to validate ${file.name} file. Please try other file(s) or later. \n Error Log:${error.message}`
            );
            this.ams.alert.afterClosed().subscribe(() => {
              this.ams.showAlert('Error', `Stack Trace: ${error.message}`);
            });
          }
          resolve('Invalid');
        },
        (bytesUploaded, bytesTotal) => {},
        () => {
          const fileId = upload.getFileId();
          let tempAttach: any = {};
          tempAttach = this.createAttachment(fileId, '', '', '0', type);
          tempAttach.value.formId = -3;

          this._dataService
            .ImportFileFromFileService(tempAttach.value)
            .subscribe({
              next: (data) => {
                this.attachId = data;
                this.ams.closeDialog();
                this.ref.markForCheck();
                resolve('Valid');
              },
              error: (error) => {
                this.ams.closeDialog();
                this.ref.markForCheck();
                this.ams.showAlert(
                  'Error',
                  `Failed to validate ${file.name} file. Please try other file or try again later`
                );
                this.ams.alert.afterClosed().subscribe(() => {
                  this.ams.showAlert('Error', `Stack Trace ${error.message}`);
                });
                resolve('Invalid');
              },
            });
        }
      );
    });
  }

  handleReaderForm(attachType: string, e) {
    let base64 = [];
    base64.push(btoa(e.target.result));
    this.ppForm.get([attachType, '0', 'attachString']).setValue(base64[0]);
  }

  DownloadAllAttachFile() {
    if (this.formId) {
      const arrayAddAttach = this.ppForm.get('AddAttach') as FormArray;
      arrayAddAttach.controls.forEach((item) => {
        this.DownloadAttachFile('AddAttach', item.value.attachName);
      });
    }
  }

  DownloadAttachFile(attachType: string, fileName) {
    const attachments = this.ppForm.get(attachType) as FormArray;
    const file = attachments.controls.find((item) => {
      return item.value.attachName === fileName;
    });
    this.ams.showLoader('Downloading...');
    if (file.value.attachId !== -1) {
      this._dataService
        .DownloadAttachmentFileById(file.value.attachId, 'PP')
        .subscribe((response) => {
          saveAs(response, `${file.value.attachName}`);
          this.ams.closeDialog();
        });
    } else {
      this.ams.showAlert(
        'Failed to download',
        `You must saved change(s) first to download ${fileName} file`
      );
    }
  }

  resetFileInput(type) {
    this.removeAttach(type);
    switch (type) {
      case 'W9Attach':
        this.fileInput1.nativeElement.value = '';
        break;
      case 'previousEffortAttach':
        this.fileInput3.nativeElement.value = '';
        break;
      case 'schematicAttach':
        this.fileInput4.nativeElement.value = '';
        break;
    }
  }

  resetAddAttach() {
    let arrayAddAttach = this.ppForm.get('AddAttach') as FormArray;
    arrayAddAttach.controls.forEach((item, index) => {
      if (item.value.attachId !== -1) {
        item.value.deleteIt = 1;
        this.AddAttachDeleted.push(item as FormControl);
      }
    });
    while (arrayAddAttach.length !== 0) {
      arrayAddAttach.removeAt(0);
    }
    this.fileInput2.nativeElement.value = '';
  }

  removeFile(fileName) {
    let arrayAddAttach = this.ppForm.get('AddAttach') as FormArray;
    arrayAddAttach.controls.forEach((item, index) => {
      if (item.value.attachName === fileName) {
        arrayAddAttach.removeAt(index);
        if (item.value.attachId !== -1) {
          item.value.deleteIt = 1;
          this.AddAttachDeleted.push(item as FormControl);
        }
      }
    });
  }

  onAddAttachFileChange(event) {
    let fileList = [];
    fileList = Array.from(event.target.files);
    if (fileList.length > 0) {
      if (fileList.length < 10) {
        let isPDFIndex = fileList.findIndex(
          (item) => item.type !== 'application/pdf'
        );
        if (isPDFIndex <= -1) {
          const newLength = fileList.length;
          const uploadedLength = this.ppForm.value.AddAttach.length;
          if (newLength + uploadedLength <= 10) {
            let uploadFileSize: number = 0;
            let currentFileSize: number = 0;
            let totalFileSize = 0;
            for (let i = 0; i < newLength; i++) {
              uploadFileSize += parseInt(fileList[i].size);
            }
            if (uploadedLength > 0) {
              for (let i = 0; i < uploadedLength; i++) {
                currentFileSize += parseInt(
                  this.ppForm.get(['AddAttach', i.toString(), 'attachSize'])
                    .value
                );
              }
            }
            totalFileSize = uploadFileSize + currentFileSize;
            if (totalFileSize < 10485760) {
              let current = fileList.map(function (item) {
                return item.name;
              });
              if (this.ppForm.value.AddAttach.length > 0) {
                let upload = this.ppForm.value.AddAttach.map(function (item) {
                  return item.attachName;
                });
                current = [...current, ...upload];
              }
              let isDuplicate = current.some(function (item, idx) {
                return current.indexOf(item) != idx;
              });

              if (!isDuplicate) {
                let AddArray = this.ppForm.get('AddAttach') as FormArray;
                for (let i = 0; i < fileList.length; i++) {
                  if (this.isInternal) {
                    let tempAddAttach = this.createAttachment(
                      'NA',
                      '',
                      fileList[i].name,
                      fileList[i].size.toString(),
                      'Additional'
                    );
                    const reader: any = new FileReader();
                    const self = this;
                    reader.onload = function (e) {
                      let i = AddArray.length;
                      let base64 = [];
                      base64.push(btoa(e.target.result));
                      tempAddAttach.value.attachString = base64[0];
                      AddArray.push(tempAddAttach);
                      self.ref.markForCheck();
                    };
                    reader.readAsBinaryString(fileList[i]);
                    this.ref.markForCheck();
                  } else {
                    this.uploadToFileService(fileList[i], 'Additional').then(
                      (result) => {
                        if (result === 'Valid') {
                          let tempAddAttach = this.createAttachment(
                            'NA',
                            '',
                            fileList[i].name,
                            fileList[i].size.toString(),
                            'Additional'
                          );
                          tempAddAttach.value.attachId = this.attachId;
                          this.attachId = -1;
                          AddArray.push(tempAddAttach);
                        }
                      }
                    );
                  }
                  this.fileInput2.nativeElement.value = '';
                }
              } else {
                this.ams.showAlert(
                  '',
                  'Some of the files are already attached'
                );
              }
            } else {
              this.ams.showAlert(
                '',
                'Attachment size exceeds the allowable limit, please remove some files'
              );
            }
          } else {
            this.fileInput2.nativeElement.value = '';
            this.ams.showAlert(
              '',
              'Number of Attachments exceeds the allowable limit(10 files), please remove some files'
            );
          }
        } else {
          this.fileInput2.nativeElement.value = '';
          this.ams.showAlert(
            '',
            'Only PDF files are allowed, please choose another file'
          );
        }
      } else {
        this.fileInput2.nativeElement.value = '';
        this.ams.showAlert(
          '',
          'Number of Attachments exceeds the allowable limit(10 files), please remove some files'
        );
      }
    }
    this.ref.markForCheck();
  }

  AutopopulateInfo() {
    this.ppForm
      .get(['OrgInfoFormPP', 'name'])
      .setValue(this.profileData.orgInfoExt.name);
    this.ppForm
      .get(['OrgInfoFormPP', 'EIN'])
      .setValue(this.profileData.orgInfoExt.EIN);
    this.ppForm
      .get(['OrgInfoFormPP', 'address1'])
      .setValue(this.profileData.orgInfoExt.address1);
    this.ppForm
      .get(['OrgInfoFormPP', 'address2'])
      .setValue(this.profileData.orgInfoExt.address2);
    this.ppForm
      .get(['OrgInfoFormPP', 'city'])
      .setValue(this.profileData.orgInfoExt.city);
    this.ppForm
      .get(['OrgInfoFormPP', 'state'])
      .setValue(this.profileData.orgInfoExt.state);
    this.ppForm
      .get(['OrgInfoFormPP', 'zipCode'])
      .setValue(this.profileData.orgInfoExt.zipCode);
    this.ppForm
      .get(['OrgInfoFormPP', 'subsection_501'])
      .setValue(this.profileData.orgInfoExt.subsection_501);
    this.ppForm
      .get(['OrgContactInfoFormPP', 'firstName'])
      .setValue(this.profileData.orgContactInfoExt.firstName);
    this.ppForm
      .get(['OrgContactInfoFormPP', 'lastName'])
      .setValue(this.profileData.orgContactInfoExt.lastName);
    this.ppForm
      .get(['OrgContactInfoFormPP', 'phone'])
      .setValue(this.profileData.orgContactInfoExt.phone);
    this.ppForm
      .get(['OrgContactInfoFormPP', 'email'])
      .setValue(this.profileData.orgContactInfoExt.email);
  }

  checkOrgName() {
    const name = this.ppForm.get(['OrgInfoFormPP', 'name']).value;
    if (name.length > 80) {
      this.ppForm.get(['OrgInfoFormPP', 'payToOption']).setValue('yes');
      if (this.ppForm.get(['OrgInfoFormPP', 'payTo']).value.length === 0) {
        this.ppForm
          .get(['OrgInfoFormPP', 'payTo'])
          .setValue(name.substring(0, 80));
      }
      this.ppForm.get(['OrgInfoFormPP', 'name']).setValue(name);
      this.isMaxLength = true;
    }
  }

  getTaxExemptStatus(value) {
    if (value === '') return 'Other';
    else if (isNaN(value) || +value === 0) {
      return value;
    } else {
      return `501(c)(${+value})`;
    }
  }

  onCancel() {
    this.toHome();
  }

  toHome() {
    const previousUrl = this.previousRouteService.getPreviousUrl();
    if (previousUrl?.includes('admin')) {
      this.router.navigate([previousUrl]);
    } else {
      this.router.navigate(['']);
    }
  }

  ngOnDestroy() {
    this.endSubscriptions();
    this._dataService.setFormCCName(null);
    this.store.dispatch(
      new PlantPlanetAction.LoadPlantPlanetStateSuccess(null)
    );
  }

  onSaveAsDraft() {
    this._dataService.setFormCCName(this.ppForm.get('projectName').value);
    this.ams.showConfirmation(
      'Are you sure you want to save as draft?',
      'PP',
      this.ppForm.get('projectName').value,
      30
    );
    this.ams.confirmation.afterClosed().subscribe((result) => {
      if (result) {
        this.checkFormExpired().subscribe({
          next: (status) => {
            this.ams.closeDialog();
            this.ref.markForCheck();
            if (status === 'Open') {
              this.ppForm.get('FormPPName').setValue(result.formName);
              this.ppForm.get('projectName').setValue(result.formName);
              this.savingDraft();

              this._dataService.setFormCCName('');
            } else {
              this.ams.showAlert(
                'Expired',
                'The application has been expired !!!'
              );
              this.ref.markForCheck();
              let leaving = setTimeout(() => {
                this.toHome();
              }, 5000);
              this.ams.alert.afterClosed().subscribe(() => {
                this.toHome();
                clearTimeout(leaving);
              });
            }
          },
        });
      }
    });
  }

  onSubmit() {
    if (this.ppForm.invalid) {
      this.ams.showAlert(
        'Alert',
        'Please complete all required field(s) marked with an *'
      );
    } else if (!this.isValid && this.isInternal) {
      this.ams.showAlert(
        'Alert',
        'Your Accounting Distribution combination is invalid!'
      );
    } else if (!this.isAttached && !this.isInternal) {
      this.ams.showAlert(
        'Alert',
        'Please attach required PDF documents marked with an *'
      );
    } else {
      // this._dataService.setFormCCName(this.ppForm.get('projectName').value);
      this.ams.showConfirmation(
        'Are you sure you want to submit?',
        'PP',
        this.ppForm.get('projectName').value,
        30
      );
      this.ams.confirmation.afterClosed().subscribe((result) => {
        if (result) {
          this.checkFormExpired().subscribe({
            next: (status) => {
              this.ams.closeDialog();
              this.ref.markForCheck();
              if (status === 'Open') {
                if (
                  this.ppForm.value.statusId === 2 ||
                  this.ppForm.value.statusId === null
                ) {
                  this.ppForm.value.statusId = 1;
                }
                this.ppForm.value.deleteIt = 'false';
                this.ppForm.value.AddAttach.push(
                  ...this.AddAttachDeleted.value
                );
                this.ppForm.value.W9Attach.push(...this.W9AttachDeleted.value);
                this.ppForm.value.schematicAttach.push(
                  ...this.SchematicAttachDeleted.value
                );
                this.ppForm.value.previousEffortAttach.push(
                  ...this.PreviousEffortAttachDeleted.value
                );
                this.ppForm.value.amount = this.totalAmount;
                this.ppForm.value.FormPPName = result.formName;
                this.ppForm.value.projectName = result.formName;
                let userId = this.ppForm.value.userId;
                userId =
                  userId === '' ? this.permissionsService.getUserId() : userId;
                this.ppForm.value.userId = userId;

                this.ams.showLoader('Submitting...');
                this._dataService.ppFormIUD(this.ppForm.value).subscribe({
                  next: (response) => {
                    this.ams.closeDialog();
                    if (response === 'error') {
                      this.ams.showAlert(
                        'Error!',
                        `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${response.message}`
                      );
                      this.ref.markForCheck();
                    } else {
                      this.isShowLeaveDialog = true;
                      this.ams.showAlert('Success!', 'Successfully submitted!');
                      this.ref.markForCheck();
                      let leaving = setTimeout(() => {
                        this.toHome();
                      }, 5000);
                      this.ams.alert.afterClosed().subscribe(() => {
                        this.toHome();
                        clearTimeout(leaving);
                      });
                    }
                  },
                  error: (error) => {
                    this.ams.closeDialog();
                    this.ref.markForCheck();
                    this.ams.showAlert(
                      'Error!',
                      `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
                    );
                  },
                });
                this._dataService.setFormCCName('');
              } else {
                this.ams.showAlert(
                  'Expired',
                  'The application has been expired !!!'
                );
              }
            },
          });
        }
      });
    }
  }

  savingDraft() {
    this.ppForm.value.statusId = 2;
    this.ppForm.value.deleteIt = 'false';
    this.ppForm.value.AddAttach.push(...this.AddAttachDeleted.value);
    this.ppForm.value.W9Attach.push(...this.W9AttachDeleted.value);
    this.ppForm.value.schematicAttach.push(
      ...this.SchematicAttachDeleted.value
    );
    this.ppForm.value.previousEffortAttach.push(
      ...this.PreviousEffortAttachDeleted.value
    );
    this.ppForm.value.userId = this.permissionsService.getUserId();

    this.ams.showLoader('Drafting...');
    this._dataService.ppFormIUD(this.ppForm.value).subscribe({
      next: (response) => {
        this.ams.closeDialog();
        if (response === 'error') {
          this.ams.showAlert(
            'Error!',
            `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${response.message}`
          );
          this.ref.markForCheck();
        } else {
          this.ams.showAlert('Success!', 'Successfully Drafted!');
          this.ref.markForCheck();
          this.isShowLeaveDialog = true;
          let leaving = setTimeout(() => {
            this.toHome();
          }, 5000);
          this.ams.alert.afterClosed().subscribe(() => {
            this.toHome();
            clearTimeout(leaving);
          });
        }
      },
      error: (error) => {
        this.ams.closeDialog();
        this.ref.markForCheck();
        this.ams.showAlert(
          'Error!',
          `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
        );
      },
    });
  }

  onSaveAccDist(): Promise<any> {
    return new Promise((resolve) => {
      this.ams.showLoader('Saving Accounting Distribution...');
      this._dataService
        .AccDistIUD(['PP', this.ppForm.value.AccDistribution])
        .subscribe({
          next: (response) => {
            this.ams.closeDialog();
            this.ref.markForCheck();
            if (response === 'error') {
              this.ams.showAlert(
                'Error!',
                `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${response.message}`
              );
              resolve('bad');
            } else {
              if (!this.isApproving) {
                this.ams.showAlert('Success!', 'Successfully Saved!');
              }
              this.ppForm.get('AccDistribution').markAsPristine();
              this.ams.closeDialog();
              this.ref.markForCheck();
              this.isShowLeaveDialog = true;
              resolve('good');
            }
          },
          error: (error) => {
            this.ams.closeDialog();
            this.ref.markForCheck();
            this.ams.showAlert(
              'Error!',
              `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
            );
            resolve('bad');
          },
        });
    });
  }

  onApprove() {
    this.isApproving = true;
    if (this.ppForm.invalid) {
      this.ams.showAlert(
        'Alert',
        'Please complete all required field(s) marked with an *'
      );
    } else if (!this.isFilled) {
      this.ams.showAlert(
        'Alert',
        'Please fill missing field(s) on Accounting Distribution!'
      );
    } else if (!this.isValid) {
      this.ams.showAlert(
        'Alert',
        'Your Accounting Distribution combination is invalid!'
      );
    } else {
      if (this.ppForm.dirty) {
        this.onSaveAccDist().then((result) => {
          if (result === 'good') {
            this.approveForm();
            this.isApproving = false;
          }
        });
      } else {
        this.approveForm();
        this.isApproving = false;
      }
    }
  }

  approveForm() {
    const data: any = {};
    data.formPPId =
      this.formData.FormPPLogInfo.formPPId == null
        ? this.ppForm.value.FormPP_Id
        : this.formData.FormPPLogInfo.formPPId;
    data.formPPLogId = this.formData.FormPPLogInfo.formPPLogId;
    data.empId = this.formData.FormPPLogInfo.empId;
    data.empName = this.formData.FormPPLogInfo.empName;
    data.action = 'Approved';
    data.orgName = this.formData.OrgInfoFormPP.name;
    data.status = this.formData.FormPPLogInfo.status;
    data.email = '';
    data.userId = this.formData.userId;
    data.empTypeForLog = this.formData.FormPPLogInfo.empTypeForLog;
    data.empTitle = this.formData.FormPPLogInfo.title;

    this.ams.showApproveReject('Are you sure you want to Approve?', '');
    this.ams.approveReject.afterClosed().subscribe((result) => {
      if (result) {
        data.comment = result.comment;
        this.ams.showLoader('Approving...');
        this._dataService.AprroveRejectWithdrawFormPP(data).subscribe({
          next: (data) => {
            if (data === 'ALREADYDONE') {
              this.ams.closeDialog();
              this.ams.showAlert(
                'Error!',
                'This request has already been approved!'
              );
            } else {
              this.ams.closeDialog();
              this.ams.showAlert('Success!', 'Successfully approved!');
            }
            this.ref.markForCheck();
            this.isShowLeaveDialog = true;
            let leaving = setTimeout(() => {
              this.toHome();
            }, 5000);
            this.ams.alert.afterClosed().subscribe(() => {
              this.toHome();
              clearTimeout(leaving);
            });
          },
          error: (error) => {
            this.ams.closeDialog();
            this.ams.showAlert(
              'Error!',
              'Resource not available, please try again later!'
            );
            this.ref.markForCheck();
          },
        });
      }
    });
  }

  onReject() {
    const data: any = {};
    data.formPPId = this.formData.FormPPLogInfo.formPPId;
    data.formPPLogId = this.formData.FormPPLogInfo.formPPLogId;
    data.empId = this.formData.FormPPLogInfo.empId;
    data.empName = this.formData.FormPPLogInfo.empName;
    data.action = 'Rejected';
    data.orgName = this.formData.OrgInfoFormPP.name;
    data.status = this.formData.FormPPLogInfo.status;
    data.email = '';
    data.userId = this.formData.userId;
    data.empTypeForLog = this.formData.FormPPLogInfo.empTypeForLog;
    data.empTitle = this.formData.FormPPLogInfo.title;

    this.ams.showApproveReject('Are you sure you want to Reject?', '');
    this.ams.approveReject.afterClosed().subscribe((result) => {
      if (result) {
        data.comment = result.comment;
        this.ams.showLoader('Rejecting...');
        this._dataService.AprroveRejectWithdrawFormPP(data).subscribe({
          next: (data) => {
            this.ams.closeDialog();
            if (data === 'ALREADYDONE') {
              this.ams.showAlert(
                'Error!',
                'This request has already been approved!'
              );
            } else {
              this.ams.showAlert('Success!', 'Successfully Rejected!');
            }
            this.ref.markForCheck();
            this.isShowLeaveDialog = true;
            let leaving = setTimeout(() => {
              this.toHome();
            }, 5000);
            this.ams.alert.afterClosed().subscribe(() => {
              this.toHome();
              clearTimeout(leaving);
            });
          },
          error: (error) => {
            this.ams.closeDialog();
            this.ref.markForCheck();
          },
        });
      }
    });
  }

  onWithdrawn() {
    const data: any = {};
    data.formPPId = this.formData.FormPPLogInfo.formPPId;
    data.formPPLogId = this.formData.FormPPLogInfo.formPPLogId;
    data.empId = this.formData.FormPPLogInfo.empId;
    data.empName =
      this.formData.FormPPLogInfo.empName === null
        ? this.formData.userId
        : this.formData.FormPPLogInfo.empName;
    data.action = 'Withdrawn';
    data.orgName = this.formData.OrgInfoFormPP.name;
    data.status = this.formData.FormPPLogInfo.status;
    data.email = '';
    data.userId = this.formData.userId;
    data.empTypeForLog = this.formData.FormPPLogInfo.empTypeForLog;
    data.empTitle = this.formData.FormPPLogInfo.title;

    this.ams.showApproveReject('Are you sure you want to Withdrawn?', '');
    this.ams.approveReject.afterClosed().subscribe((result) => {
      if (result) {
        data.comment = result.comment;
        this.ams.showLoader('Withdrawing...');
        this._dataService.AprroveRejectWithdrawFormPP(data).subscribe({
          next: (data) => {
            this.ams.closeDialog();
            this.ams.showAlert('Success!', 'Successfully Withdrawn!');
            this.ref.markForCheck();
            this.isShowLeaveDialog = true;
            let leaving = setTimeout(() => {
              this.toHome();
            }, 5000);
            this.ams.alert.afterClosed().subscribe(() => {
              this.toHome();
              clearTimeout(leaving);
            });
          },
          error: (error) => {
            this.ams.closeDialog();
            this.ref.markForCheck();
          },
        });
      }
    });
  }
}
